import { useMemo } from "react";
import { getTplLabel } from "../utils/getTplLabel";

export const useSelectionDetails = ({ selectedTpls, filterScopes, annotationCounts }) =>
  useMemo(
    () => ({
      templatesLabel:
        selectedTpls.map((tpl) => getTplLabel(tpl)).join(", ") || "None selected",
      scopesLabel: filterScopes.length ? filterScopes.join(", ") : "No scopes enabled",
      annotationSummary: `Tags: ${annotationCounts?.tags ?? 0} · Sub-Themes: ${annotationCounts?.subThemes ?? 0} · Themes: ${annotationCounts?.themes ?? 0}`,
    }),
    [selectedTpls, filterScopes, annotationCounts]
  );


